const CSS_CLASSES = {
	ACTIONS: 'root__container__actions',
	CONTAINER: 'root__container',
};

export { CSS_CLASSES };
